import { useContext } from 'react';
import { GraphQLClientContext } from './GraphQLClientProvider';
import { GraphQLClient } from 'graphql-request';

export const useGraphQLClient = (): GraphQLClient => {
  const client = useContext(GraphQLClientContext);

  if (!client) {
    throw new Error('useGraphQLClient must be used within a GraphQLClientProvider');
  }

  return client;
};
